<template>
  <q-page padding>
<!--    <base-nested-list resource="csiCodes"></base-nested-list>-->
    <simple-tree resource="csiCodes"></simple-tree>
  </q-page>
</template>

<script>
// import BaseNestedList from "components/tree/BaseNestedList";
import SimpleTree from "components/tree/SimpleTree";

export default {
  name: 'Tree',
  components: {
    SimpleTree,
    // BaseNestedList
  }
}
</script>
